import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import './Checkbox.css';

const Checkbox = forwardRef(
    (
        {
            children,
            className,
            isChecked,
            isDisabled,
            isReadOnly,
            onChange,
            value,
        },
        ref
    ) => {
        return (
            <div className={`${className} ab-checkbox-cnt`}>
                <label
                    className="ab-checkbox-label"
                    data-disabled={isDisabled}
                    data-checked={isChecked}
                    data-readonly={isReadOnly}
                >
                    <input
                        aria-disabled={isDisabled}
                        aria-readonly={isReadOnly}
                        className="ab-checkbox"
                        type="checkbox"
                        onChange={onChange}
                        checked={isChecked}
                        ref={ref}
                        disabled={isDisabled}
                        readOnly={isReadOnly}
                        value={value}
                    />
                    <div>{children}</div>
                </label>
            </div>
        );
    }
);

Checkbox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Checkbox.defaultProps = {
    className: '',
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;
